import { useNavigate } from 'react-router-dom';
import { Section, PaddedContent, icons, record, Button, Loading } from 'daymap-library';
import Alert, {ALERT_TYPE} from '../../components/Alert/Alert';
import { useApp } from '../../helpers/appContext';
import { useAuth } from '../../helpers/authContext';
import { useEffect, useState, useRef, useCallback } from 'react';
import StudentCodeInput from '../StudentCodeInput/StudentCodeInput';
import StudentSearch from '../StudentSearch/StudentSearch';
import styles from './StudentCodeEntry.module.scss';

function StudentCodeEntry({ onStudentFound, getCurrentLocation }) {
    const { lmsFetch } = useAuth();
    const { settings } = useAuth();
    const [studentCode, setStudentCode] = useState('');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { appType, mode } = useApp();
    const codeInput = useRef(null);
  
    const goClicked = useCallback(async () => {
      //navigate('/kiosk/records')
      setError(null);
      setLoading(true);
        const [ex] = lmsFetch('/lms/api/checkin/student?input=' + encodeURI(studentCode) + (getCurrentLocation ? '&getCurrentLocation=true' : ''));
      const response = await ex();
      
      if (response.error)
        setError('Could not find a student using the term ' + studentCode);
      else 
        onStudentFound && onStudentFound(response.data);
      
      setLoading(false);
    }, [studentCode, onStudentFound, getCurrentLocation, lmsFetch])

    const onNumPadKey = key => {
      switch (key) {
        case 'submit':
          goClicked();
          break;
        case 'delete':
          setStudentCode(studentCode.substring(0, studentCode.length - 1));
          break;
        default:
          setStudentCode(`${studentCode}${key}`);
          break;
      }
    }
  
    useEffect(() => {
      if (!appType || !mode) {
        console.log('App type or mode not set, redirecting to mode selection screen');
        navigate('/');
      }
  
      codeInput.current?.focus();
  
    }, []);

    // whenever studentcode is updated check if the end char matches the barcode end key that is set in the 'Swipe Card End Key' setting
    useEffect(() => {
      if (studentCode?.length > 0 && !isNaN(settings.BarcodeEndKey)) {
        const endChar = Number(settings.BarcodeEndKey);
        if (studentCode.charCodeAt(studentCode.length - 1) === endChar) {
          goClicked();
        }
      }
    }, [studentCode, goClicked, settings.BarcodeEndKey])

    const { SearchByFirstName, SwipeCardField, SearchByText, SearchByTextLength } = settings;

    let displayText = "Swipe Student Card or enter Student ID";

    if(SearchByFirstName || SearchByText){
      displayText = "Swipe Student Card, enter Student ID or enter Student Name"
    }

    if (SwipeCardField && !SearchByText)
      displayText = `Enter Student ${SwipeCardField.Caption}`;

    let usePinPad = !SearchByText && SwipeCardField && (SwipeCardField.ControlType === record.CONTROL_TYPE.NumericTextbox || SwipeCardField.DataType === record.DATA_TYPE.Number);
    
    return (
      <Section>
        <form onSubmit={goClicked}>
          <PaddedContent style={{display: 'flex', alignItems: 'center', flexFlow: 'column', gap: '.7rem'}}>
            <p>{displayText}</p>
              <div className={styles.InputWrapper}>
              {SearchByText && !usePinPad ?
                <StudentSearch onChange={setStudentCode} icon={icons.ICON_CSS_CLASS.Visitor} ref={codeInput} requiredLength={SearchByTextLength} /> :
                <StudentCodeInput onChange={setStudentCode} config={{ disabled: loading }} ref={codeInput} value={studentCode} elementType={usePinPad ? 'password' : 'text'} />
                }
              {usePinPad && <NumberPad onKeyEntered={onNumPadKey} disabled={loading} />}
              </div>
              {error && <Alert type={ALERT_TYPE.Error} heading="Error searching">{error}</Alert>}
              {!loading && !usePinPad && <Button text="Go" large iconClass={icons.ICON_CSS_CLASS.Play} onClick={goClicked} />}
              {loading && <Loading message="Searching for student" />}
          </PaddedContent>
        </form>
      </Section>
    )
  }

  const NumberPad = ({ onKeyEntered, disabled }) => {
    return (
      <div className={styles.NumberPad}>
        {[1,2,3,4,5,6,7,8,9,'delete',0,'submit'].map(i => {
          let iconClass = null;
          let label = `${i}`;

          if (i === 'delete') {
            iconClass = icons.ICON_CSS_CLASS.LeftChevron;
            label = 'Del';
          }
          else if (i === 'submit') {
            iconClass = icons.ICON_CSS_CLASS.Play;
            label = 'Go'
          }

          return <Button
            disabled={disabled} 
            secondary
            className={styles.Button} 
            text={label} 
            iconClass={iconClass}
            onClick={() => onKeyEntered(i)} />
        })}
      </div>
    )
  }

  export default StudentCodeEntry;